import { EntryWithID } from '@/cms/types/entry';

import ImageStrapi from '../../atoms/Image/ImageStrapi';
import RichTextFieldStrapi from '../../atoms/RichTextField/RichTextFieldStrapi';
import { RelatedArticlesProps } from '../relatedArticles';

export type ArticleItem = RelatedArticlesProps['items'][number];

export function transformBlogArticlesIntoRelatedArticlesProps(
  articles: EntryWithID[]
) {
  return articles.map((article) => {
    const author = article.blog_author?.data?.attributes;

    return {
      slug: `/blog/${article.slug}`,
      releaseDate: article.metadata?.releaseDate,
      author: {
        authorPageSlug: author?.authorPageSlug,
        name: author?.name ?? '',
        image: !!author?.image && (
          <ImageStrapi
            block={author.image}
            inner={{
              classNames: { image: 'rounded-full w-9' },
              width: 36,
              height: 36,
            }}
          />
        ),
      },
      description: (
        <RichTextFieldStrapi
          block={article.metadata?.description}
          classNames={{ link: { root: 'hover:no-underline text-inherit' } }}
        />
      ),
      herotitle: article.metadata?.title,
      image: !!article.metadata?.image && (
        <ImageStrapi
          block={{
            ...article.metadata.image,
          }}
          inner={{
            classNames: {
              container: 'overflow-hidden rounded-xl',
              image: '!object-cover min-h-[200px] w-full md:min-w-[494px]',
            },
          }}
        />
      ),
      isNew: article.metadata?.newUntil
        ? new Date(article.metadata.newUntil) > new Date()
        : false,
      timeSpentReading: article.metadata?.timeSpentReading,
      topics:
        article.metadata?.topics?.data?.map((topic) => ({
          topic: topic.attributes.topic,
          slug: topic.attributes.slug,
        })) ?? [],
    } satisfies ArticleItem;
  });
}
